import { RootState } from "../../../../store";
import { ResourceExplorerPath } from "../../../utils/types/resourceExplorer";
import { resourceExplorerStateSelector } from "../../resourceExplorerStateSelector";

export const resourceExplorerPathSelector = (
  state: RootState,
): ResourceExplorerPath[] => {
  return resourceExplorerStateSelector(state).path;
};
